/**
 * DAH Authentication Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoginRequestDto { 
    clientId?: LoginRequestDto.ClientIdEnum;
    clientType?: LoginRequestDto.ClientTypeEnum;
    deviceId?: string;
    login?: string;
    password?: string;
}
export namespace LoginRequestDto {
    export const ClientIdEnum = {
        BackOffice: 'BACK_OFFICE',
        TempCabinet: 'TEMP_CABINET',
        OsbbClientMobile: 'OSBB_CLIENT_MOBILE',
        DahClientMobile: 'DAH_CLIENT_MOBILE',
        AfsClientMobile: 'AFS_CLIENT_MOBILE',
        OsbbCabinetWeb: 'OSBB_CABINET_WEB',
        DahClientWeb: 'DAH_CLIENT_WEB',
        AfsClientWeb: 'AFS_CLIENT_WEB'
    } as const;
    export type ClientIdEnum = typeof ClientIdEnum[keyof typeof ClientIdEnum];
    export const ClientTypeEnum = {
        Ios: 'IOS',
        Android: 'ANDROID',
        Web: 'WEB'
    } as const;
    export type ClientTypeEnum = typeof ClientTypeEnum[keyof typeof ClientTypeEnum];
}


